import { defineMessages } from "react-intl";
export default defineMessages({
  actionsLabel: {
    id: "jutro-quick-view.actionsLabel",
    defaultMessage: "Actions"
  }
});